module.exports = __webpack_public_path__ + "media/images/home/boxes/clean_administration-24014c9af37ce133bdf4a05e3bf7c380.svg";